var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgLightbulb12 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.57723 6.02846L8 8L7 10V11C7 11.5523 6.55228 12 6 12H4C3.44772 12 3 11.5523 3 11V10L2 8L0.422769 6.02846C0.149098 5.68637 0 5.26133 0 4.82324C0 2.15944 2.15944 0 4.82324 0H5.17676C7.84056 0 10 2.15944 10 4.82324C10 5.26133 9.8509 5.68637 9.57723 6.02846ZM6.3059 6.91606L5.76393 8H4.23607L3.6941 6.91606L2.00011 4.79857C2.01335 3.2507 3.27224 2 4.82324 2H5.17676C6.72776 2 7.98665 3.2507 7.99989 4.79857L6.3059 6.91606Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLightbulb12);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;